module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-editor-modal-wrapper",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "map-editor-modal-container row",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "map-editor"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "address-input"
  }, [_c('input-places', {
    staticClass: "col-md-6 col-md-offset-3",
    attrs: {
      "attrs": {
        id: 'input-places-map-editor',
        placeholder: _vm.attrs.placeholder
      }
    },
    on: {
      "place-selected": _vm.setPositionFromAddress
    }
  })], 1), _vm._v(" "), (_vm.showHelp) ? _c('div', {
    staticClass: "map-help col-md-3",
    attrs: {
      "transition": "fade"
    }
  }, [_c('a', {
    staticClass: "close clickable",
    on: {
      "click": function($event) {
        _vm.showHelp = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('map.help')))])]) : _vm._e(), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ok')) + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c153eb4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/markerEdit/MapEditor.vue
// module id = 1060
// module chunks = 1